





















import Vue from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    props: {
        //  Determines is the component is disabled (Overrides loading, and validDiscount)
        disabled: {
            type: Boolean,
            default: false
        },
        //  Determines the max width of the component
        maxWidth: {
            type: String,
            default: null
        },
        //  Applies the outlined theme
        outlined: {
            type: Boolean,
            default: false
        },
        //  Applies the solo theme
        solo: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            discountCode: null,
            error: null,
            loading: false,
            validDiscount: null,
            props: {
                solo: this.solo
            }
        }
    },
    mounted() {
        const coupon =
            this.subscription &&
            this.subscription.discount &&
            this.subscription.discount.coupon &&
            this.subscription.discount.coupon.id

        if (coupon) {
            this.discountCode = coupon

            this.validateDiscount()
        }
    },
    computed: {
        ...mapGetters(['subscription']),
        appendIcon(): object {
            if (this.validDiscount) {
                return {
                    icon: 'bi-trash-fill',
                    color: 'grey darken-2',
                    callback: () => this.reset()
                }
            }
            return {
                icon: 'mdi-plus-circle',
                color: this.disabled ? 'grey' : 'primary',
                callback: () => this.validateDiscount()
            }
        },
        placeholder(): string {
            if (this.disabled) return 'Enter card info before applying discount code'
            else return 'Apply Discount Code'
        }
    },
    methods: {
        async applyDiscount(): Promise<void> {
            //  Start loading
            this.loading = true

            //  Wait for our discount to apply
            await this.$store.dispatch('couponsPost')

            //  Stop loading
            this.loading = false
        },
        async reset(): Promise<void> {
            //  Start loading
            this.loading = true

            //  Remove the discount code
            const sub = await this.$store.dispatch('couponsRemove')

            //  Regardless, stop loading
            this.loading = false

            //  If it failed, do nothing
            if (!sub) return

            //  Else, reset everything else
            this.discountCode = null
            this.validDiscount = null
            this.$refs.discountBox.focus()
        },
        async validateDiscount(): Promise<string> {
            //  If a code does NOT exist, show error
            if (!this.discountCode) return null

            //  Reset any existing errors
            this.error = null

            //  Else, start the loader
            this.loading = true

            //  Verify the coupon exists with the API
            const coupon = await this.$store.dispatch('couponsGet', this.discountCode)

            //  Stop the loader
            this.loading = false

            //  If the request failed, do nothing
            if (!coupon) return

            //  If an error exists, post it to the 'errors' channel
            if (coupon.error) return (this.error = coupon.error)

            //  Else, set the valid coupon
            this.validDiscount = coupon

            //  Apply the discount and wait
            await this.applyDiscount()

            //  Emit valid coupon id to parent
            this.$emit('validCodeEntered', this.validDiscount.id)
        }
    }
})
